<template>
  <div class="pageWrap" :class="[userAgent=='PHONE'?'first':'first2']">
      <div class="first-title"></div>
      <div class="loubg" :class="[userAgent=='PHONE'?'loubg':'loubg2']"></div>
    <div class="clouds_one"></div>
    <div class="clouds_two"></div>
    <div class="clouds_three"></div>
    <div class="clouds_four"></div>

    <div :class="[userAgent=='PHONE'?'xiaozun':'xiaozun2']"></div>
    <div  :class="[userAgent=='PHONE'?'zhaopai':'zhaopai2']"></div>
  </div>
</template>

<script>
export default {
  name: "first.vue",
  data(){
    return{
      userAgent:'',
    }
  },
  mounted() {
    this.userAgent=this.obtainCurrPlatform();
  },
  methods:{
    obtainCurrPlatform:()=>{
      // 判断当前使用的平台 PC PHONE
      let ios = /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent);
      let android = /(Android)/i.test(navigator.userAgent);
      // console.log(ios,android)
      if(ios||android){
        const deviceWidth = document.documentElement.clientWidth || document.body.clientWidth;
        // deviceWidth = 750px(设计图w)
        // document.querySelector('html').style.fontSize = deviceWidth / 100 / 7.5 + 'px';
        document.documentElement.style.fontSize = deviceWidth / 100 / 7.5 + 'px';
        return 'PHONE'
      }else{
        return 'PC'
      }
    }
  }
}


</script>

<style scoped>
.first{
  position: relative;
  width: 100%;
  height: 100vh;
  background: url("../../public/guangming_milk/one/one_bg.png") no-repeat;
  background-size: 100% 100%;
}
.first2{
  position: relative;
  width: 100%;
  height: 1331px;
  background: url("../../public/guangming_milk/one/one_bg.png") no-repeat;
  background-size: 100% 100%;
}
.loubg{
  z-index: 2;
  width: 100%;
  height: 100vh;
  background: url("../../public/guangming_milk/one/one_lou3.png") no-repeat;
  background-size: 750px 100vh;
  background-position: bottom;
  position: absolute;
  bottom:0px;
  left: 0;
}
.loubg2{
  z-index: 2;
  height: 1331px;
  width: 750px;
  background: url("../../public/guangming_milk/one/one_lou3.png") no-repeat;
  background-size: 100% 100%;
  background-position: bottom;
  position: absolute;
  bottom:0px;
  left: 0;
}
.first-title{
  z-index: 2;
  width: 423px;
  height: 265px;
  background: url("../../public/guangming_milk/title/1text3.png") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  top: 75px;
  left: calc(50% - 212px);
}
.clouds_one{
  z-index: 1;
  position: absolute;
  width: 136px;
  height: 59px;
  background: url("../../public/guangming_milk/one/yun1.png") no-repeat;
  background-size: 100% 100%;
  top: 398px;
  right: -80px;
  -webkit-animation: cloud_one 70s linear infinite;
  -moz-animation: cloud_one 70s linear infinite;
  -o-animation: cloud_one 70s linear infinite;
  -webkit-transform: translate3d(0, 0, 0);
  -moz-transform: translate3d(0, 0, 0);
  -o-transform: translate3d(0, 0, 0)
}
.clouds_two{
  z-index: 1;
  position: absolute;
  width: 147px;
  height: 87px;
  background: url("../../public/guangming_milk/one/yun2.png") no-repeat;
  background-size: 100% 100%;
  top: 470px;
  right: 0;
  -webkit-animation: cloud_two 45s linear infinite;
  -moz-animation: cloud_two 45s linear infinite;
  -o-animation: cloud_two 45s linear infinite;
  -webkit-transform: translate3d(0, 0, 0);
  -moz-transform: translate3d(0, 0, 0);
  -o-transform: translate3d(0, 0, 0)
}
.clouds_three{
  /*z-index: 1;*/
  /*position: absolute;*/
  /*width: 121px;*/
  /*height: 68px;*/
  /*background: url("../../public/guangming_milk/one/yun4.png") no-repeat;*/
  /*background-size: 100% 100%;*/
  /*top: 231px;*/
  /*right: -40px;*/
}
.clouds_four{
  z-index: 1;
  position: absolute;
  width: 148px;
  height: 75px;
  background: url("../../public/guangming_milk/one/yun3.png") no-repeat;
  background-size: 100% 100%;
  top: 370px;
  right: -140px;
  -webkit-animation: cloud_four 85s linear infinite;
  -moz-animation: cloud_four 85s linear infinite;
  -o-animation: cloud_four 85s linear infinite;
  -webkit-transform: translate3d(0, 0, 0);
  -moz-transform: translate3d(0, 0, 0);
  -o-transform: translate3d(0, 0, 0)
}
@-webkit-keyframes cloud_one {
  0%{
    right: 0px;
  }
  100%{
    right: 110%;
  }
}
@-webkit-keyframes cloud_two {
  0%{
    right: -200px;
  }
  100%{
    right: 120%;
  }
}
@-webkit-keyframes cloud_four {
  0%{
    left: 120%;
  }
  100%{
    left: -200px;
  }
}
.xiaozun{
  width: 300px;
  height: 25.4vh;
  background: url("../../public/guangming_milk/one/1-xiaozun2.gif") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  z-index: 11;
  bottom: 0.5vh;
  left: calc(50% - 135px);
}
.xiaozun2{
  width: 300px;
  height: 340px;
  background: url("../../public/guangming_milk/one/1-xiaozun2.gif") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  z-index: 11;
  bottom: 5px;
  left: calc(50% - 135px);
}
.zhaopai{
  width: 664px;
  /*height: 306px;*/
  height: 23vh;
  background: url("../../public/guangming_milk/one/zhaopai3.gif") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  z-index: 11;
  bottom: 26.2vh;
  left: 85px;
}
.zhaopai2{
  width: 664px;
  height: 306px;
  background: url("../../public/guangming_milk/one/zhaopai3.gif") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  z-index: 11;
  bottom: 349px;
  left: 85px;
}
</style>
